var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 22,
    viewBox: "0 0 41 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1264 10.9998C23.1264 17.0749 17.9494 22 11.563 22C5.17663 22 0 17.0764 0 10.9998C0 4.92323 5.17703 0 11.563 0C17.949 0 23.1264 4.92471 23.1264 10.9998ZM35.8116 10.9998C35.8116 16.7188 33.2229 21.3545 30.0299 21.3545C26.8369 21.3545 24.2482 16.7173 24.2482 10.9998C24.2482 5.28233 26.8369 0.645128 30.0299 0.645128C33.2229 0.645128 35.8116 5.28233 35.8116 10.9998ZM41 10.9998C41 16.1237 40.0895 20.2772 38.9665 20.2772C37.8435 20.2772 36.933 16.1223 36.933 10.9998C36.933 5.87738 37.8435 1.72244 38.9669 1.72244C40.0902 1.72244 41 5.87626 41 10.9998Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.0cfdaf47.svg";
export { ForwardRef as ReactComponent };